import React from "react";
import BookmarkListSkeleton from "../Bookmark/BookmarkListSkeleton";

const BookmarkSkeleton: React.FC = () => {
  return (
    <div className="relative pt-10 pb-14 ps-14 pe-11 max-xl:py-6 max-xl:pe-8 max-md:p-0">
      <h2 className="text-primary text-2xl mb-6 max-md:mb-4 max-md:text-lg max-sm:hidden">
        Bookmarks
      </h2>

      <div className="w-full max-md:max-h-full">
        <div className="flex items-center justify-start gap-6 overflow-auto max-md:gap-4 w-full pb-2 mb-2">
          <div className="text-[#89D9EE] text-2xl max-md:text-xl flex-shrink-0 hover:opacity-100 flex items-center gap-1">
            All
          </div>
          <div className="text-[#89D9EE] text-2xl max-md:text-xl flex-shrink-0 hover:opacity-100 flex items-center gap-1">
            Episodes
          </div>
          <div className="text-[#89D9EE] text-2xl max-md:text-xl flex-shrink-0 hover:opacity-100 flex items-center gap-1">
            Music
          </div>
        </div>

        <div className="max-h-[600px] overflow-auto flex flex-col gap-3 mb-12 max-sm:mb-0 max-md:max-h-full">
          <BookmarkListSkeleton />
        </div>
      </div>
    </div>
  );
};

export default BookmarkSkeleton;
